function isScrolledToBottom() {
  const windowHeight = window.innerHeight;
  const documentHeight = document.documentElement.scrollHeight;
  const scrollTop = window.scrollY;
  const menuHeight = getComputedStyle(document.documentElement).getPropertyValue('--menu-height').replace('px','');
  return (documentHeight - windowHeight - menuHeight <= Math.ceil(scrollTop));
}

function handleScroll() {
  const header = document.querySelector('header-root');
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  const searchModalOpen = document.querySelector('.search-open#snize-modal-sticky-searchbox');

  if (screenWidth > 850 && screenHeight > 900) {
    if (isScrolledToBottom() && !searchModalOpen) {
      header.classList.add('move-content-up');
    } else {
      header.classList.remove('move-content-up');
    }
  } else {
    header.classList.remove('move-content-up');
  }
}

window.addEventListener('scroll', handleScroll);
